import { useState, useEffect } from "react";
import { FaArrowUp, FaFacebookMessenger, FaComments } from "react-icons/fa";
import { SiZalo } from "react-icons/si";
import { motion, AnimatePresence } from "framer-motion";
import "./FloatingButtons.css";

const FloatingButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [openContacts, setOpenContacts] = useState(false);

  const phoneNumber = "0704888009";
  const messengerUsername = "www.design24.edu.vn";

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Mở Messenger (ưu tiên app, fallback web)
  const openMessenger = () => {
    if (isMobile) {
      const appUrl = `fb-messenger://user-thread/${messengerUsername}`;
      const webUrl = `https://m.me/${messengerUsername}`;
      const timeout = setTimeout(() => {
        window.open(webUrl, "_blank");
      }, 800);
      window.location.href = appUrl;
      setTimeout(() => clearTimeout(timeout), 2000);
    } else {
      window.open(`https://m.me/${messengerUsername}`, "_blank");
    }
  };

  // Mở Zalo (ưu tiên app, fallback web)
  const openZalo = () => {
    if (isMobile) {
      const appUrl = `zalo://qr/p/${phoneNumber}`;
      const webUrl = `https://zalo.me/${phoneNumber}`;
      const timeout = setTimeout(() => {
        window.open(webUrl, "_blank");
      }, 800);
      window.location.href = appUrl;
      setTimeout(() => clearTimeout(timeout), 2000);
    } else {
      window.open(`https://zalo.me/${phoneNumber}`, "_blank");
    }
  };

  const contactButtons = [
    {
      onClick: openZalo,
      icon: <SiZalo />,
      class: "zalo-btn",
      title: "Chat Zalo",
    },
    {
      onClick: openMessenger,
      icon: <FaFacebookMessenger />,
      class: "messenger-btn",
      title: "Chat Messenger",
    },
  ];

  return (
    <>
      {/* Scroll to top */}
      <AnimatePresence>
        {showScrollTop && (
          <motion.button
            key="scrollTop"
            onClick={scrollToTop}
            className="floating-btn scroll-top-btn"
            title="Lên đầu trang"
            style={{
              bottom: openContacts ? 24 + contactButtons.length * 60 + 80 : 120,
            }}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            whileHover={{ scale: 1.15, rotate: 180 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaArrowUp />
          </motion.button>
        )}
      </AnimatePresence>

      {/* Contact group */}
      <div className="contact-group">
        <motion.button
          className="floating-btn hub-btn"
          title="Liên hệ"
          onClick={() => setOpenContacts(!openContacts)}
          whileHover={{ scale: 1.15, rotate: 10 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaComments
            style={{
              transform: openContacts ? "scale(1.2)" : "none",
              transition: "0.3s",
            }}
          />
        </motion.button>

        {/* Contact children */}
        <AnimatePresence>
          {openContacts &&
            contactButtons.map((btn, i) => (
              <motion.button
                key={btn.title}
                onClick={btn.onClick}
                className={`floating-btn ${btn.class}`}
                title={btn.title}
                initial={{ opacity: 0, y: 0 }}
                animate={{ opacity: 1, y: -(i + 1) * 60 }}
                exit={{ opacity: 0, y: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                  damping: 20,
                  delay: i * 0.05,
                }}
                whileHover={{ scale: 1.15 }}
                whileTap={{ scale: 0.95 }}
              >
                {btn.icon}
              </motion.button>
            ))}
        </AnimatePresence>
      </div>
    </>
  );
};

export default FloatingButtons;
